
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import '../../stylesheet/regmodal.css';




const ActivationFailed = props => {
    
    
    // const classes = useStyles();

    return (
        <Modal
            open={props.open}
            className="col-sm-12 flow-modal">
            <div
                className="modal-content col-sm-6"
                style={{ background: "#fff", color: "#fff" , minHeight:"350px"}}>
                <div
                    position="static"
                    className="modal-header"
                    style={{ background: "#fff", padding: "10px" }}>
                    <div className="col-sm-12">
                        <div className="row">
                            {/* <div
                                className="col-sm-6"
                                style={{ fontSize: "19px", fontWeight: "600", color: "#fff" }}>
                                <span>Status</span>
                            </div> */}
                            <div
                                className="col-sm-12"
                                style={{ float: "right" }}>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    style={{ marginTop: "-19px", color: "#333" }}
                                    onClick={props.onClose}
                                    aria-label="Close">
                                    <span
                                        aria-hidden="true"
                                        style={{ color: "#333", fontSize: "30px" }}>
                                        &times;
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal-body text-left"
                    style={{ color: "#3e3e3e" , minHeight : '225px' }}>
                    <div className="col-sm-12">
                        <div className="col-sm-12" >
                            <i
                                className="fa fa-exclamation-triangle fa-4x mb-3 animated rotateIn"
                                style={{ color: "#323435" }}>
                            </i>
                        </div>
                        <div
                            className="col-sm-12"
                            style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px",color:"#ff0000" }}>
                            {(props.attempts === 3) &&

                                <p> After 3 attempts we are unable to verify your identification document. Please contact us by clicking here
                                    <span style={{ color: "blue", cursor: "pointer" }} onClick={props.handleContactUs}> <u>Contact Us </u></span>
                                     or call xxxx xxxx to speak to one of our customer service representatives</p>
                            }
                            {(props.attempts <= 2 ) &&
                            <p>{props.message}</p> 
                            }
                              {(props.message && props.attempts === undefined) &&
                            <p>{props.message}</p> 
                            }
                            


                        </div>
                        <div className="col-sm-12" style={{ fontSize: "14px" }}>
                            <div className="row col-md-12" style={{ display: "flex", justifyContent: "left" }}>
                                <div className="" >
                                    <Button className="btn btn-std" onClick={props.onClose} >
                                        OK
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ActivationFailed


// WEBPACK FOOTER //
// ./src/components/register/activationfailed.jsx